import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Pdpa from "@/pages/Pdpa";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Residents from "@/pages/Residents";
import Units from "@/pages/Units";
import Payments from "@/pages/Payments";
import VehiclePlates from "@/pages/VehiclePlates";
import Reports from "@/pages/Reports";
import Notifications from "@/pages/Notifications";
import SubmitPayment from "@/pages/SubmitPayment";
import MyPayments from "@/pages/MyPayments";
import PaymentStatus from "@/pages/PaymentStatus";
import Profile from "@/pages/Profile";
import SecurityDashboard from "@/pages/SecurityDashboard";
import ComingSoon from "@/pages/ComingSoon";
import VisitorLog from "@/pages/VisitorLog";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login"           element={<Login />} />
          <Route path="/register"        element={<Register />} />
          <Route path="/pdpa"            element={<Pdpa />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password"  element={<ResetPassword />} />
          <Route path="/" element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }>
            <Route index             element={<Dashboard />} />
            <Route path="residents"  element={<Residents />} />
            <Route path="units"      element={<Units />} />
            <Route path="payments"   element={<Payments />} />
            <Route path="vehicles"   element={<VehiclePlates />} />
            <Route path="reports"    element={<Reports />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="submit-payment" element={<SubmitPayment />} />
            <Route path="my-payments"    element={<MyPayments />} />
            <Route path="payment-status" element={<PaymentStatus />} />
            <Route path="profile"        element={<Profile />} />
            <Route path="security"       element={<SecurityDashboard />} />
            <Route path="my-visitors"    element={
              <ComingSoon
                title="My Visitors"
                description="Visitor invitations for residents are coming soon. Please check back later."
              />
            } />
            <Route path="visitor-log"    element={<VisitorLog />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
